import {
    SHOW_FREIGHT_TYPES_POPUP,
    HIDE_FREIGHT_TYPES_POPUP,   
    FREIGHT_TYPES_REQUEST,
    FREIGHT_TYPES_SUCCESS,
    FREIGHT_TYPES_FAIL   
} from '../constants/action-types';

const initialState = {
    fetching: false,
    freightTypePopupVisible: false,
    freightTypePopupData: {},   
    freightTypes: [],      
    data: []
}

export default function freights(state = initialState, action) {    
    switch (action.type) {
        case SHOW_FREIGHT_TYPES_POPUP:     
            return {
                ...state,
                freightTypePopupVisible: true,
                popupData: action.formData,
                freightTypePopupData: {
                    mode: action.mode,    
                    data: action.data 
                }
            }
        case HIDE_FREIGHT_TYPES_POPUP:
            return {
                ...state,
                freightTypePopupVisible: false,               
                freightTypePopupData: {}                
            }        
        case FREIGHT_TYPES_REQUEST:
            return {
                ...state,
                fetching: true
            }
        case FREIGHT_TYPES_SUCCESS:
            return {
                ...state,
                fetching: false,
                data: action.payload,
                freightTypes: action.payload,
            }
        case FREIGHT_TYPES_FAIL:
            return {
                ...initialState,
                fetching: false,
            }        
        default:
            return state;
  }

}



// WEBPACK FOOTER //
// ./source/reducers/freights.js